import React from "react";
import "./assets/tailwind.css";
import MainComponentWrapper from "./MainComponentWrapper";
import * as serviceWorker from "./serviceWorker";
import { createRoot } from "react-dom/client";

createRoot(document.getElementById("root")!).render(<MainComponentWrapper />);

serviceWorker.unregister();
